"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserController = void 0;
const api_1 = require("@streem/api");
const domain_id_1 = require("@streem/domain-id");
const toolbox_1 = require("@streem/toolbox");
const operators_1 = require("rxjs/operators");
const streem_error_1 = require("../../streem_error");
const logger_1 = require("../../util/logger");
const filter_empty_array_1 = require("../../util/rx/filter_empty_array");
const first_from_group_1 = require("../../util/rx/first_from_group");
const utils_1 = require("../wall/utils");
class UserController {
    constructor(config) {
        var _a, _b, _c, _d, _e;
        this.config = config;
        this.users = this.config.roomWall.itemsByType.pipe((0, utils_1.findInGroup)('user'), (0, utils_1.accumulateAndTransformWallEvents)('user', (wi) => __awaiter(this, void 0, void 0, function* () {
            var _f, _g, _h, _j, _k, _l;
            // [STREEM-8122] Android sends its user wall items as {user_id}:{device_id}. Use ownerUserId for compatability.
            const userSid = new domain_id_1.UserId(wi.ownerUserId || wi.id).toString();
            try {
                const { user: userData } = yield api_1.StreemAPI.users.getUser(userSid);
                return Object.assign(Object.assign({}, wi), { ownerUserId: userSid, id: userSid, name: (_f = wi.name) !== null && _f !== void 0 ? _f : '', 
                    // Note: onsite streems do not post the photo url
                    photoURL: (_h = (_g = wi.avatarUrl) !== null && _g !== void 0 ? _g : userData === null || userData === void 0 ? void 0 : userData.avatarUrl) !== null && _h !== void 0 ? _h : '', 
                    // Hacky solution until we actually set the customer phone number for new customers
                    phone: (userData === null || userData === void 0 ? void 0 : userData.phone) ||
                        (((_j = userData === null || userData === void 0 ? void 0 : userData.externalUserId) === null || _j === void 0 ? void 0 : _j.startsWith('+'))
                            ? userData === null || userData === void 0 ? void 0 : userData.externalUserId
                            : undefined) });
            }
            catch (e) {
                logger_1.logger.warn('Failed to fetch additional user information: continuing without');
                return Object.assign(Object.assign({}, wi), { id: userSid, name: (_k = wi.name) !== null && _k !== void 0 ? _k : '', photoURL: (_l = wi.avatarUrl) !== null && _l !== void 0 ? _l : '' });
            }
        })), (0, filter_empty_array_1.filterEmptyArray)(), (0, operators_1.shareReplay)(1));
        this.localUser = this.users.pipe((0, utils_1.filterByProperty)('ownerUserId', (_b = (_a = config.context.localUserId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : 'NEVER'), (0, first_from_group_1.firstFromGroup)(), (0, operators_1.shareReplay)(1));
        this.remoteUsers = this.users.pipe((0, utils_1.excludeByProperty)('ownerUserId', (_d = (_c = config.context.localUserId) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : 'NEVER'), (0, operators_1.shareReplay)(1));
        this.remoteUser = this.users.pipe((0, utils_1.filterByProperty)('ownerUserId', (_e = config.context.remoteUserId) === null || _e === void 0 ? void 0 : _e.toString()), (0, first_from_group_1.firstFromGroup)());
    }
    getUser(userId) {
        return this.users.pipe((0, utils_1.filterByProperty)('id', userId.toString()), (0, first_from_group_1.firstFromGroup)());
    }
    addLocalUserToWall() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.localUserId, 'Expected localUserId to be defined when adding a local user to the wall');
            const { user } = yield api_1.StreemAPI.users.getUser(this.config.context.localUserId.toString());
            if (user && !user.name) {
                user.name = 'Streem User';
            }
            if (!user || !user.sid || !user.name) {
                throw new streem_error_1.StreemError('Unable to get user details.');
            }
            const userInfo = {
                name: user.name,
                avatarUrl: user.avatarUrl,
            };
            logger_1.logger.info('User has been added to the wall', this.config.context.localUserId.toString());
            this.config.roomWall.addUserItem(this.config.context.localUserId, userInfo);
        });
    }
}
exports.UserController = UserController;
//# sourceMappingURL=user_controller.js.map